import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Sabés qué vas a comer antes de abrir la heladera', 'Cocinás en menos de 20 minutos con ingredientes simples', 'Usás tu air fryer todos los días, no solo los fines de semana', 'Comés más liviano sin hacer dieta ni prohibirte nada'];
  return <section className="py-20 px-4 bg-white" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <div className="inline-flex bg-brand-purpleLight text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6" data-id="element-193">
            La solución
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray mb-4" data-id="element-194">
            Presentamos "Recetas en Air Fryer: ricas, fáciles y rápidas"
          </h2>
          <p className="text-lg text-brand-mediumGray max-w-2xl mx-auto font-medium" data-id="element-195">
            El único ebook diseñado para personas que no saben cocinar, tienen
            poco tiempo, y quieren empezar HOY mismo.
          </p>
        </div>

        <div className="flex justify-center mb-16" data-id="element-196">
          <img src="https://cdn.magicpatterns.com/uploads/gvNRSBs7CPvvhShmiBmZAh/AC358B5D-8A9E-4683-8767-26B49CF693EA.png" alt="Ebook Recetas en Air Fryer" className="w-full max-w-md drop-shadow-2xl" data-id="element-197" />
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-198">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md border border-gray-50" data-id="element-199">
              <div className="bg-brand-yellow w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-200">
                <Check className="w-5 h-5 text-brand-purpleDark" strokeWidth={3} data-id="element-201" />
              </div>
              <p className="text-brand-darkGray font-semibold text-lg leading-snug" data-id="element-202">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}